<script lang="ts">
  import Modal from '../../Modal.svelte';
  import Button from '../../Button.svelte';
  import { CreateRoute, Route, Target } from '../../../utils/routing.service.js';
  import FormInput from '../../form/FormInput.svelte';
  import FormRadioGroup from '../../form/FormRadioGroup.svelte';
  import FormCheckbox from '../../form/FormCheckbox.svelte';

  export let isOpen: boolean;
  export let route: Route | undefined = undefined;
  export let onCreateRoute: (route: CreateRoute) => void;
  export let onUpdateRoute: (route: Route) => void;

  let urlPath = '';
  let target: Target = '3.0';
  let wildcard: boolean = true;
  let canSubmit = false;

  const targetOptions = [
    { label: '3.0', value: '3.0' },
    { label: '4.0', value: '4.0' }
  ];

  const resetForm = () => {
    urlPath = '';
    target = '3.0';
    wildcard = false;
    route = undefined
  };

  const apply = async () => {
    if (route) {
      onUpdateRoute({
        ...route,
        url_path: urlPath,
        target,
        wildcard
      });
    } else {
      onCreateRoute({
        url_path: urlPath,
        target,
        wildcard
      });
    }
  };

  const cancel = () => {
    isOpen = false;
  };

  const onRouteChange = () => { 
    urlPath = route ? route.url_path : '';
    target = route ? route.target : '3.0';
    wildcard = route ? route.wildcard : false;
  };

  const checkIsValid = () => {
    canSubmit = false;

    if (urlPath) {
      canSubmit = true;
    }
  };

  $: route, onRouteChange();
  $: urlPath, target, wildcard, checkIsValid();
</script>

<Modal
  label={route ? 'Routing-Anweisung bearbeiten' : 'Routing-Anweisung hinzufügen'}
  bind:isOpen
  onClose={resetForm}
>
  <FormInput
    label="URL-Pfad"
    bind:value={urlPath}
    dataTestid="urlPath"
    description="Dieser URL-Pfad soll eine Routing-Anweisung erhalten"
    showEncodeButton
  />

  <FormRadioGroup
    options={targetOptions}
    label="Target"
    name="target"
    description="Soll die URL auf die 3.0 oder auf die 4.0 geroutet werden?"
    bind:selected={target}
    on:change={event => {
      target = event.detail.value;
    }}
  />

  <FormCheckbox
    label="Verzeichnis-Flag"
    bind:checked={wildcard}
    description="Zeigt der URL-Pfad auf ein Verzeichnis und sollen alle Seiten in diesem Verzeichnis die Routing-Anweisung erhalten oder soll nur eine einzelne Seite/URL die Routing-Anweisung erhalten?"
  />

  <svelte:fragment slot="button">
    <Button on:click={cancel}>Abbrechen</Button>
    <Button on:click={apply} disabled={!canSubmit} variant="primary" dataTestid={'apply'}>
      {route ? 'Änderungen übernehmen' : 'Weiterleitung erstellen'}
    </Button>
  </svelte:fragment>
</Modal>
